// extracted by mini-css-extract-plugin
export default {"contain":"Discount_contain__sLQyj","discount":"Discount_discount__5DHRk"};